var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.todayIsBetweenDates(_vm.start, _vm.end))?_c('span',{staticClass:"mr-2"},[_c('badge',{staticClass:"todaybadge"},[_vm._v("\n        "+_vm._s(_vm.$t('vfair.activeNow'))+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }